module.exports = __webpack_public_path__ + "uy.f40123c175dff9d1d8f7.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/uy.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/uy.svg
// module chunks = styles